import {sprintf} from '@/angular/libs/sprintf';

export function getValueFormatter(prefix, suffix, digits=2) {
    return function(value, onlyPositive=false){
        if (onlyPositive){
            value = Math.abs(value)
        }

        const valueFormatted = value.toFixed(digits).toString()
        return (prefix ? prefix + ' ' : '') + valueFormatted + (suffix ? ' ' + suffix : '');
    }  
}

export function getValueFormatterWithMeta(meta){
    return function (value) {
        if (meta && meta.formatWithUnit) {
            return sprintf(meta.formatWithUnit.replace('F', 'f'), value);
        } else {
            return value;
        }
    }
}

export function getValueFormatterWithDecimals(prefix, suffix) {
    return function(value, onlyPositive=false){
        if (onlyPositive){
            value = Math.abs(value)
        }

        const roundedValue = Math.round((value + Number.EPSILON) * 10000) / 10000; // use Number.EPSILON to avoid floating point errors

        // Split the value into integer and decimal parts
        let [integerPart, decimalPart] = roundedValue.toString().includes('.')
        ? roundedValue.toString().split('.')
        : roundedValue.toString().split(',');

        decimalPart = (decimalPart || "").padEnd(2, '0'); // Add minimum 2 decimal places

        const valueFormatted = `${integerPart}.${decimalPart}`;

        return (prefix ? prefix + ' ' : '') + valueFormatted + (suffix ? ' ' + suffix : '');
    }  
}